import { HUMAN_SORT } from 'types/deck'

import PhatDropdown from 'components/formElements/PhatDropdown'

import { useActions, useAppSelector } from 'app-redux/hooks'
import { setDeckStateAction } from 'app-redux/deck/actions'

import { setLocalSortDirectionDescending, setLocalSorting, setLocalView } from 'services/accountSettings.service'

export const sortOptions = Object.keys(HUMAN_SORT).map(text => ({
  text,
  key: HUMAN_SORT[text],
  value: HUMAN_SORT[text],
}))

type Props = {
  noExtras?: boolean
  onViewAsChange?: () => void
}

const DeckSortByDropdown = ({ noExtras, onViewAsChange }: Props) => {
  const sort = useAppSelector(state => state.deck.sorting)
  const sortDirectionDescending = useAppSelector(state => state.deck.sortDirectionDescending)

  const [setDeckState] = useActions(setDeckStateAction)

  const handleSortChange = (_e: any, { value }: any) => {
    setDeckState({ sorting: value })
    setLocalSorting(value)
  }

  const handleChangeSortDirection = () => {
    setDeckState({ sortDirectionDescending: !sortDirectionDescending })
    setLocalSortDirectionDescending(!sortDirectionDescending)
  }
  return (
    <PhatDropdown
      fixedMenu
      matchMenuWidthToParent
      header="Sort by"
      icon={sortDirectionDescending ? 'sort amount down' : 'sort amount up'}
      value={sort}
      options={[
        {
          label: 'Order descending',
          onChange: handleChangeSortDirection,
          type: 'checkbox',
          checked: sortDirectionDescending,
        },
        { type: 'spacer' },
        ...sortOptions.map(opt => ({
          label: opt.text,
          id: `${opt.value}`,
          onClick: () => handleSortChange(null, { value: opt.value }),
        })),
      ]}
    />
  )
}

export default DeckSortByDropdown
